import packingList from "./../../../src/img/Israel/Packing_List_Israel.pdf";
import styles from "./../../Styles/PackingList.module.scss";

function packinglist() {
  const adapters = {
    href: "https://www.amazon.com/One-Beat-Converter-Jerusalem-Palestine/dp/B0CJHM1Z9C/ref=sr_1_3?crid=O28W2XSVOD5A&amp;dib=eyJ2IjoiMSJ9.wVwlPh39aXO2rjFPkDmV7wk0XYt3dht6MqJXgRO5F19KZzf-Xn2hU8hxAJZmE5uX3h1N2BO_hpfb49ahp-7SlMmPsb7VR1lNqQPPHnxXWbmUo6w9cdZBCEmKHIp9639G_u-6ReiVeGoW5c09vWtvK6Pjf-tPF-mobplLy9b0qV-MOj5iAMaVIW9qGp4nz8gx8sKyDx2CZOG7WXxSnKLLrR-0_gmgb7O_bKvR7U1Wv0U.98bP9GVy-dM1k6j7tzj-_7Hqoq3W2ZRIHxjsAGg9YuM&amp;dib_tag=se&amp;keywords=adapters%2Bfor%2Bisrael%2Btravel&amp;qid=1766950507&amp;sprefix=adapters%2Bfor%2BIsrael%2Caps%2C170&amp;sr=8-3&amp;th=1",
    target: "_blank"
  };

  return (
    <div className="pageContainer">
      <p className="title">Suggested Packing List</p>
      <div className="printBox">
        {/* <div className="print">
          <a href={packingList} target="_blank" rel="noreferrer">
            Print PDF
          </a>
        </div> */}
      </div>

      <p className="text">
        My advice is to pack light. Most people make the mistake of overpacking.
      </p>

      <p className={`text ${styles.highlightOrange}`}>
        I recommend that you take……
      </p>
      <p className="text">
        A debit card so that you can get Israeli shekels at an ATM.
      </p>
      <p className="text">
        You can take a small amount of American cash, but I wouldn’t take too
        much. Probably best to keep it at $300 or under. You should be able to
        convert you dollars to shekels.
      </p>
      <p className="text">
        I would take one or two credit cards. Most places will accept MasterCard
        and Visa as payment. Check with your bank to see if they charge a three
        percent international transaction fee. Some do and some do not.
      </p>
      <p className={`text ${styles.highlightBlue}`}>
        LET YOUR BANK(S) KNOW THAT YOU WILL BE IN ISRAEL AND TO EXPECT CHARGES
        TO COME THROUGH ON YOUR DEBIT AND CREDIT CARDS. IF YOU FAIL TO DO THIS,
        THEY MAY SHUT DOWN YOUR CARD BECAUSE THEY SUSPECT FRAUD.
      </p>
      <p className={`text ${styles.highlightOrange}`}>
        Don’t forget your passport. And make sure it is valid (not due to expire
        for at least six months after you return home). If not, they will not
        let you board the airplane departing the USA.
      </p>
      <ul className={`text ${styles.list}`}>
        <li>
          Two copies of the main page of your passport (take one copy with you
          and leave one copy at home with someone). If you lose your passport,
          having a copy makes it easier to get a provisional one overseas.
        </li>
        <li>
          If you have medical insurance, take some information or your card with
          you proving you have it.
        </li>
        <li>
          The weather should be warm in October, but the evenings could be cool,
          so you might want a light jacket.
        </li>
        <li>
          Clothes--not too many, about 4-5 changes of clothes. You don’t need
          any dress clothes.
        </li>
        <li>
          Laundry soap (very small amount, or you can buy some there and share
          it)
        </li>
        <li>
          Most people hand wash clothes in their hotel room. It is usually very
          expensive to send out your laundry for someone to do it.
        </li>
        <li>
          A washcloth if you use one. Most overseas hotels do not provide this.
        </li>
        <li>
          Adapters to plug in your electronics. Here is the link for Amazon
          where you can order an adapter that will work in Israel{" "}
          <a {...adapters} rel="norferrer" className={styles.link}>
            Click here
          </a>
        </li>
        <li>Medicines and supplements that you usually take.</li>
        <li>Small Bible or Bible app on your phone.</li>
        <li>
          You can buy an Israel SIM card for your phone if you want one. (They
          are usually $30-$40 for a month). This will give you internet and GPS
          wherever you go. Or contact your cell phone provider and see if you
          can get an international calling plan for the weeks you will be gone.
        </li>
        <li>Take good walking/hiking shoes.</li>
        <li>
          Soft ear plugs to block any night noises that might keep you from
          sleeping and to block noisy children on the airplane. You can buy a
          package of these inexpensively at Walmart..{" "}
        </li>
        <li>Most hotels have hairdryers.</li>
        <li>
          I recommend that you don’t take anything that has a heating element in
          it. Curling iron, hair dryer, etc.
        </li>
      </ul>
    </div>
  );
}

export default packinglist;
